export default __webpack_public_path__ + "static/media/arrow.c0064d37.svg";